import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyCTABar } from './components/StickyCTABar';
interface AppProps {
  showAnnouncementBar?: boolean;
  showStickyCTA?: boolean;
}
export function App({
  showAnnouncementBar = true,
  showStickyCTA = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-orange/25" data-id="element-0" data-mp="3mkhmhu9cv461">
      {showAnnouncementBar && <AnnouncementBar data-id="element-1" data-mp="3rd17vdeab3le" />}
      <main data-id="element-2" data-mp="5yhupa6n3cr">
        <HeroSection data-id="element-3" data-mp="6hqffdy0fe4" />
        <StatsBar data-id="element-4" data-mp="4wx1t3d72hu" />
        <TransformationSection data-id="element-5" data-mp="5ghbgghm2z1" />
        <PainPointsSection data-id="element-6" data-mp="2zl39tfhhuw2o" />
        <KitContentsSection data-id="element-7" data-mp="2zlv6ktmtuzuj" />
        <InstantAccessSection data-id="element-8" data-mp="2zmo557bmuj1l" />
        <BonusesSection data-id="element-9" data-mp="2zng32ospcsv1" />
        <PricingSection data-id="element-10" data-mp="33m5b01uz1i7a" />
        <GuaranteeSection data-id="element-11" data-mp="33nq9g2keplaf" />
        <TestimonialsSection data-id="element-12" data-mp="33mylndx1wrup" />
        <FAQSection data-id="element-13" data-mp="38lrs4mdx7ild" />
        <FinalCTASection data-id="element-14" data-mp="38li8rhnds9on" />
      </main>
      <Footer data-id="element-15" data-mp="38kgkgbhctqoz" />
      {showStickyCTA && <StickyCTABar data-id="element-16" data-mp="3dkuvm2e95gr8" />}
    </div>;
}